<template>
	<div>
		<div class="row">
			<div class="col-12 mt-1 col-md-5 Aligner-Header">
				<h3>Total Stock Overview
					<span>
						<toggle-button 
							v-model="mappingBoolean.stockOverview"
							:width="100"
							:height="25"
							color="#7dCE94" 
							:sync="true" 
							:labels="{checked: 'H-1', unchecked: 'Real Time'}"
						/>
					</span>
				</h3>
			</div>
		</div>
		<stats
			:data="data.stockOverview"
			:dataDocument="data.stockOverviewDocument"
			:dataVirtual="data.stockOverviewVirtual"
			:dataSipbUnfill="data.stockOverviewSipbUnfill"
			:dataIndent="data.stockOverviewStockInden"
		></stats>

		<!-- Sales Vs Stock -->
		<div class="row mt-5" style="padding-right:1%">
			<div class="col-12 col-md-5 Aligner-Header" style="justify-content: center;">
				<h3>Stock & Sales
					<!-- <span>
						<toggle-button 
							v-model="mappingBoolean.mainDealer"
							:width="100"
							:height="25"
							color="#7dCE94" 
							:sync="true" 
							:labels="{checked: 'H-1', unchecked: 'Real Time'}"
						/>
					</span> -->
				</h3>
			</div>
			<div class="col-12 col-md-7 row">
				<!-- <div class="col-12 col-md-4"></div> -->
				<div class="col-12 col-md-4 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.region.map(x => x.code)"
						:custom-label="opt => options.region.find(x => opt == x.code).name"
						:allow-empty="true"
						v-model="filter.stockSales.region"
						placeholder="All Region"
					/>
				</div>
				<div class="col-12 col-md-4 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.stockSales.subSeries.map(x => x.subSeries)"
						:allow-empty="true"
						v-model="filter.stockSales.series"
						placeholder="All Sub Series"
					/>
				</div>
				<div class="col-12 col-md-4 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.stockSales.type.map(x => x.type)"
						:allow-empty="true"
						v-model="filter.stockSales.tyoe"
						placeholder="All Type"
					/>
				</div>
				<div class="col-12 col-md-4 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.stockSales.color.map(x => x.color)"
						:custom-label="opt => options.stockSales.color.find(x => x.color == opt).name"
						:allow-empty="true"
						v-model="filter.stockSales.color"
						placeholder="All Color"
					/>
				</div>
			</div>
			<div class="content-outer col-12">
				<div class="content-inner" style="padding: 0 3%">
					<!-- {{data.stockSales}} -->

					<StockSales 
						class="w-100"
						v-if="data.stockSales"
						:data="data.stockSales"
					/>
					<div v-else class="text-center mt-3 mb-3">
						<h4>Loading....</h4>
					</div>

					<!-- <p class="mt-2" style="color:grey;font-size:13px;font-weight:bold">Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p> -->
				</div>
			</div>
		</div>
		<!-- End -->

		<!-- Main Dealer Stock Start -->
		<div class="row mt-5" style="padding-right:1%">
			<div class="col-12 col-md-5 Aligner-Header" style="justify-content: center;">
				<h3>Main Dealer Stock
					<span>
						<toggle-button 
							v-model="mappingBoolean.mainDealer"
							:width="100"
							:height="25"
							color="#7dCE94" 
							:sync="true" 
							:labels="{checked: 'H-1', unchecked: 'Real Time'}"
						/>
					</span>
				</h3>
			</div>
			<div class="col-12 col-md-7 row">
				<div class="col-12 col-md highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.mainDealerStock.segment.map(x => x.segment)"
						:allow-empty="true"
						v-model="filter.mainDealerStockOptions.segment"
						placeholder="All Segment"
					/>
				</div>
				<div class="col-12 col-md highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.mainDealerStock.type.map(x => x.type)"
						:allow-empty="true"
						v-model="filter.mainDealerStockOptions.type"
						placeholder="All Type"
					/>
				</div>
				<div class="col-12 col-md highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.mainDealerStock.color.map(x => x.color)"
						:custom-label="opt => options.mainDealerStock.color.find(x => x.color == opt).name"
						:allow-empty="true"
						v-model="filter.mainDealerStockOptions.color"
						placeholder="All Color"
					/>
				</div>
			</div>
			<div class="col-md-5 col-12"></div>
			<div class="col-12 col-md-7 row">
				<div class="col-md"></div>
				<div class="col-12 col-md mt-auto mb-auto text-center">
					<input class="form-check-input" type="checkbox" v-model="showEmptyMD" id="defaultCheck1">
					<label class="form-check-label ml-3" style="font-size:14px">
						Show All Warehouse
					</label>
				</div>
				<div class="col-12 col-md highlightFilter">
					<button
						type="button"
						class="mt-1 btn btn-warning w-100"
						style="height:90%"
						@click="exportExcel('mainDealerStock', 'Main Dealer Stock')"
					>Download XLS <i class="fas fa-download"></i></button>
				</div>
			</div>
			</div>
			<div class="content-outer">
			<div class="content-inner" style="padding: 0 3%">
				<main-dealer-stock
				v-if="data.mainDealerStock"
				:data="data.mainDealerStock"
				:showEmpty="showEmptyMD"
				></main-dealer-stock>
				<!-- <p class="mt-2" style="color:grey;font-size:13px;font-weight:bold">Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p> -->
			</div>
			</div>
			<!-- Main Dealer Stock End -->

			<!-- Dealer Stock Start -->
			<div class="row mt-5" style="padding-right:1%">
			<div class="col-12 col-md-5 Aligner-Header" style="justify-content: center;">
				<h3>Dealer Stock
					<span>
						<toggle-button 
							v-model="mappingBoolean.dealer"
							:width="100"
							:height="25"
							color="#7dCE94" 
							:sync="true" 
							:labels="{checked: 'H-1', unchecked: 'Real Time'}"
						/>
					</span>
				</h3>
			</div>
			<div class="col-12 col-md-7 row">
				<div class="col-12 col-md-3 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.dealerStock.karesidenan.map(x => x.code)"
						:custom-label="opt => options.dealerStock.karesidenan.find(x => x.code == opt).name"
						:allow-empty="true"
						v-model="filter.dealerStockOptions.karesidenan"
						placeholder="All Karesidenan"
					/>
				</div>
				<div class="col-12 col-md-3 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.dealerStock.city.map(x => x.code)"
						:custom-label="opt => options.dealerStock.city.find(x => x.code == opt).name"
						:allow-empty="true"
						v-model="filter.dealerStockOptions.city"
						placeholder="All City"
					/>
				</div>
				<div class="col-12 col-md-3 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.dealerStock.segment.map(x => x.segment)"
						:allow-empty="true"
						v-model="filter.dealerStockOptions.segment"
						placeholder="All Segment"
					/>
				</div>
				<div class="col-12 col-md-3 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.dealerStock.type.map(x => x.type)"
						:allow-empty="true"
						v-model="filter.dealerStockOptions.type"
						placeholder="All Type"
					/>
				</div>
				<div class="col-md-3"></div>
				<div class="col-12 col-md-3 mt-auto mb-auto text-center">
					<input class="form-check-input" type="checkbox" v-model="showEmptyD" id="defaultCheck1">
					<label class="form-check-label ml-3" style="font-size:14px">
						Show All Dealer
					</label>
				</div>
				<div class="col-12 col-md-3 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.dealerStock.color.map(x => x.color)"
						:custom-label="opt => options.dealerStock.color.find(x => x.color == opt).name"
						:allow-empty="true"
						v-model="filter.dealerStockOptions.color"
						placeholder="All Color"
					/>
				</div>
				<div class="col-12 col-md-3 highlightFilter">
					<button
						type="button"
						class="mt-1 btn btn-warning w-100"
						style="height:90%"
						@click="exportExcel('dealerStock' , 'Dealer Stock')"
					>Download XLS <i class="fas fa-download"></i></button>
				</div>
			</div>
			</div>
			<div class="content-outer">
			<div class="content-inner" style="padding: 0 3%">
				<dealer-stock
				:data="data.dealerStock"
				:showEmpty="showEmptyD"
				></dealer-stock>
				<!-- <p class="mt-2" style="color:grey;font-size:13px;font-weight:bold">Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p> -->
			</div>
			
		</div>
		<!-- Dealer Stock End -->
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'

import stats from './../children/stats.vue'
import mainDealerStock from './../children/mainDealerStock.vue'
import dealerStock from './../children/dealerStock.vue'
import StockSales from './../children/stockSalesChart.vue'

const XLSX = require('xlsx')
import listUrl from './../listUrl.js'
import DateRangePicker from 'vue2-daterange-picker'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
	components: {
		Multiselect,
		DateRangePicker,
		ToggleButton,
		// Components
		stats,
		mainDealerStock,
		dealerStock,
		StockSales
	},
	props: ['data', 'filter' , 'rangeOption'],
	data () {
		return {
			test : false,
			options : {
				mainDealerStock : this.$store.getters.getFilterOptions,
				dealerStock : this.$store.getters.getFilterOptions,
				stockSales : this.$store.getters.getFilterOptions,
				region : [{
					name : 'M2Z - Surabaya',
					code : 'M2Z'
				}, {
					name : 'M3Z - Malang',
					code : 'M3Z'
				}]
			},
			optionRangeMapping : 'Semester',
			mappingBoolean : {
				stockOverview : true,
				mainDealer : true,
				dealer : true
			},
			labelMapping : '',
			moment : moment,
			showEmptyMD : false,
			showEmptyD : false
		}
	},
	mounted() {
		this.$emit('search')

		

	},
	watch : {
		'filter.mainDealerStockOptions.segment' () {
			this.filter.mainDealerStockOptions.type = ''
			this.options.mainDealerStock.type = this.$store.getters.getTypeBySingleId(null, this.filter.mainDealerStockOptions.segment, null);
		},
		'filter.dealerStockOptions.karesidenan' () {
			this.filter.dealerStockOptions.city = ''
			this.options.dealerStock.city = this.$store.getters.getCityBySingleId(this.filter.dealerStockOptions.karesidenan);
		},
		'filter.dealerStockOptions.segment' () {
			this.filter.dealerStockOptions.type = ''
			this.options.dealerStock.type = this.$store.getters.getTypeBySingleId(null, this.filter.dealerStockOptions.segment, null);
		},
		"filter.mainDealerStockOptions": {
		  deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.stockOverview.mainDealerStock
		    let params = listUrl.param.stockOverview.mainDealerStock

		    this.$emit('loadAPI' , url , params )
		  }
		},
		"filter.stockSales": {
		  deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.stockOverview.stockSales
		    let params = listUrl.param.stockOverview.stockSales

		    this.$emit('loadAPI' , url , params )
		  }
		},
		"filter.dealerStockOptions": {
		  deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.stockOverview.dealerStock
		    let params = listUrl.param.stockOverview.dealerStock

		    this.$emit('loadAPI' , url , params )
		  }
		},
		'mappingBoolean.stockOverview' : function() {
			this.filter.stockOverview.period = !this.mappingBoolean.stockOverview ? new moment().format('Y-MM-DD') : new moment().add(-1 , 'days').format('Y-MM-DD')

			let url = listUrl.stringUrl.stockOverview.stats
			let params = listUrl.param.stockOverview.stats

			this.$emit('loadAPI' , url , params)
		},
		'mappingBoolean.mainDealer' : function() {
			this.filter.mainDealerStockOptions.period = !this.mappingBoolean.mainDealer ? new moment().format('Y-MM-DD') : new moment().add(-1 , 'days').format('Y-MM-DD')

		},
		'mappingBoolean.dealer' : function() {
			this.filter.dealerStockOptions.period = !this.mappingBoolean.dealer ? new moment().format('Y-MM-DD') : new moment().add(-1 , 'days').format('Y-MM-DD')
		}
	},
	methods : {
		async exportExcel (data , filename) {
			if(filename == 'Main Dealer Stock') {
				try {
					let exportFileName = 'Main Dealer Stock.xls'
					let wb = XLSX.utils.book_new()
					console.log(this.data[data])

					// let tryData = {"gudang": {
					// 	"M2Z-Surabaya": [
					// 		{
					// 			"gudang": "MKT",
					// 			"name": "Gudang Marketing",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "GD1",
					// 			"name": "Gudang Gedangan",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "JBG",
					// 			"name": "Gudang Jombang",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "KPG",
					// 			"name": "Gudang Kupang unit",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "PRB",
					// 			"name": "Gudang Probolinggo",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "GD2",
					// 			"name": "Gudang Gedangan2",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "JMD",
					// 			"name": "Gudang Jemundo",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "KRN",
					// 			"name": "Gudang Krian",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "MD1",
					// 			"name": "Gudang Madiun",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "STO",
					// 			"name": "Gudang Suntrako",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "XD1",
					// 			"name": "Gudang Simpang Dukuh",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "PRB2",
					// 			"name": "GUDANG PROBOLINGGO 2",
					// 			"region": "M2Z-Surabaya",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		}
					// 	],
					// 	"M3Z-Malang": [
					// 		{
					// 			"gudang": "ML2",
					// 			"name": "Gudang Sewa",
					// 			"region": "M3Z-Malang",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "ML1",
					// 			"name": "Gudang Malang",
					// 			"region": "M3Z-Malang",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		},
					// 		{
					// 			"gudang": "ML3",
					// 			"name": "Gudang Sewa Krian",
					// 			"region": "M3Z-Malang",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		}
					// 	],
					// 	"A1234-Unknown": [
					// 		{
					// 			"gudang": "A1234",
					// 			"name": "Test Location QTrust",
					// 			"region": "A1234-Unknown",
					// 			"intransit_ahm_md": 0,
					// 			"warehouse_stock_onhand": 0,
					// 			"pending_do": 0,
					// 			"virtual_stock": 0
					// 		}
					// 	]
					// },
					// "sipb_unfill": []
					// }

					//Gudang
					let keys = Object.keys(this.data[data]['gudang'])
					// let keys = Object.keys(tryData['gudang'])
					let gudangData = []
					for(var i = 0; i < keys.length ; i ++) {
						gudangData = gudangData.concat(this.data[data]['gudang'][keys[i]])
						// gudangData = gudangData.concat(tryData['gudang'][keys[i]])
					}
					let ws1 = XLSX.utils.json_to_sheet(gudangData, {raw:true});
					XLSX.utils.book_append_sheet(wb, ws1, "Gudang")

					//SIPB Unfill
					let ws2 = XLSX.utils.json_to_sheet(this.data[data]['sipb_unfill'] ? this.data[data]['sipb_unfill'] : [], {raw:true});
					// let ws2 = XLSX.utils.json_to_sheet(tryData['sipb_unfill'] ? tryData['sipb_unfill'] : [], {raw:true});
					XLSX.utils.book_append_sheet(wb, ws2, "SIPB Unfill")

					let responseDetail = await this.$http.get('/api/highlight/detail-main-dealer-stock?period=' + this.filter.mainDealerStockOptions.period)

					let data2 = responseDetail.data.data

					let ws3 = XLSX.utils.json_to_sheet(data2 , {raw : true})
					XLSX.utils.book_append_sheet(wb , ws3 , 'Vehicle Details')

					XLSX.writeFile(wb, exportFileName)
				}
				catch(err) {
					console.log(err)
				}
			}
			else {
				let exportFileName = 'Dealer Stock.xls'
				let wb = XLSX.utils.book_new()
				var ws = XLSX.utils.json_to_sheet(this.data[data], {raw:true});
				XLSX.utils.book_append_sheet(wb, ws, 'Data')
				XLSX.writeFile(wb, exportFileName)
			}

			
		}
	}
}
function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}
</script>
